const getIsProduction = () => process.env.REACT_APP_ENVIRONMENT === 'master';
export const ENVIRONMENT = getIsProduction() ? 'PRODUCTION' : 'PREPROD';
export const isProductionEnv: boolean = getIsProduction();
